import React from 'react';
import './Skills.css';
// import MonsterTruckGame from './games/MonsterTruckGame';

const Skills = () => {
  const skillsData = [
    {
      title: "AI-Powered Applications",
      description: "Build intelligent systems using LLMs, prompt pipelines, and adaptive workflows.",
    },
    {
      title: "Agentic Workflows",
      description: "Design autonomous systems that plan, execute, and iterate tasks using multi-step reasoning.",
    },
    {
      title: "LLM Orchestration",
      description: "Orchestrate complex AI flows using LangChain, APIs, and structured prompt chaining.",
    },
    {
      title: "Retrieval-Augmented Generation (RAG)",
      description: "Build context-aware AI systems using vector databases and semantic search.",
    },
    {
      title: "System Architecture & Scalability",
      description: "Design scalable, modular architectures for enterprise-grade web and AI systems.",
    },
    {
      title: "Full-Stack Engineering",
      description: "React, TypeScript, Node.js, APIs, microservices, and performance optimization.",
    },
    {
      title: "Data-Driven Applications",
      description: "Design systems that leverage analytics, user behavior, and real-time data processing.",
    },
    {
      title: "Interactive Learning Systems",
      description: "Build simulations, SCORM-compliant modules, and engagement-driven educational tools.",
    },
    {
      title: "Accessibility-First Engineering",
      description: "WCAG 2.2 AA compliant systems with inclusive UX and global usability standards.",
    },
    {
      title: "DevOps & CI/CD Automation",
      description: "Automated pipelines, deployments, and testing workflows for reliable delivery.",
    },
  ];

  return (
    <div className="skills-content">
      <h2 className="skills-title">Proficiencies</h2>
      <div className="skills-grid">
        {skillsData.map((skill, index) => (
          <div key={index} className="skill-box">
            <h3 className="skill-title">{skill.title}</h3>
            <p className="skill-description">{skill.description}</p>
            
          </div>
        ))}
      </div>
      {/* <MonsterTruckGame /> */}
    </div>
  );
}

export default Skills;
